// extracted by mini-css-extract-plugin
export default {"container":"DropdownOption_container__RljXP"};